import { Icons } from './Icons';

export const initialErrors = {
  firstName: String() || null,
  lastName: String() || null,
  description: String() || null,
  phoneNumber: String() || null,
  email: String() || null,
  country: String() || null,
  city: String() || null,
  language: String() || null,
  currency: String() || null,
  password: String() || null
}

export const initialCustomer = {
  firstName: String() || null,
  lastName: String() || null,
  description: String() || null,
  phoneNumber: String() || null,
  email: String() || null,
  password: String() || null,
  merchant: false,
  utilities: {
    country: "Iraq",
    city: "Baghdad",
    language: "ar",
    currency: "IQD"
  },
  aiUsage: {
    lastRequest: null,
    success: null,
    thisDay: null,
    thisWeek: null,
    thisMonth: null,
    totalAiUsage: null,
  },
  aiEnabled: null
};

export type initialCustomerType = typeof initialCustomer;
export type initialErrorsType = typeof initialErrors;

export const customersTableHead = [
    {
      id: 'name',
      numeric: true,
      label: 'Name',
    },
    {
      id: 'phoneNumber',
      numeric: true,
      label: 'Phone Number',
    },
    {
      id: 'location',
      numeric: true,
      label: 'Location',
    },
    {
      id: 'state',
      numeric: true,
      label: 'Status',
    },
    {
      id: 'createdAt',
      numeric: true,
      label: 'CreatedAt',
    },
    {
      id: '',
      numeric: false,
      label: '',
    },
  ];

export const customerPredefinedOptions = [
  { label: 'دفع كامل', labelEN: 'Full Payment', color: '#E53935', icon: Icons.Cash },
  { label: 'بدون عربون', labelEN: 'Without Deposit', color: '#43A047', icon: Icons.Check },
  { label: 'يلزم دفع عربون', labelEN: 'Deposit Required', color: '#F9A825', icon: Icons.Coin }
];